import { DisposePool } from "@phosphor/utils";
import { getDefaultStore } from "jotai";
import { createRoot } from "react-dom/client";
import { KeyboardDemoApp } from "#scripts/keyboard-demo/components/KeyboardDemoApp.tsx";
import { createKeyboardDemo } from "#scripts/keyboard-demo/createKeyboardDemo.ts";
import { ActionsPlugin } from "#scripts/keyboard-demo/plugins/ActionsPlugin.ts";
import { CFocusable } from "#scripts/keyboard-demo/plugins/CFocusable.ts";
import { ProvideAppDevStateRenderers } from "#scripts/lib/dev/app-dev-state-renderers.tsx";
import { WorldStateImpl } from "#scripts/vmc/WorldState-impl.ts";
import { ProvideWorldStateDev } from "#scripts/world-state-demo/ProvideWorldStateDev.tsx";
import { rootLogger } from "#scripts/world-state-demo/rootLogger.ts";

let hasInitialized = false;

function bootstrap() {
  const demoElement = document.getElementById("keyboard-demo");

  if (!demoElement) {
    console.warn("Keyboard demo: no demo element found");
    return;
  }

  if (hasInitialized) {
    console.log("Keyboard demo: already initialized, skipping");
    return;
  }

  hasInitialized = true;
  rootLogger._debug("Initializing keyboard demo...");

  const store = getDefaultStore();
  const pool = new DisposePool();

  const world = new WorldStateImpl(rootLogger, {
    store,
    pool,
    plugins: [CFocusable.Plugin, ActionsPlugin],
    strict: true,
  });

  const { rootUID } = createKeyboardDemo(world);

  rootLogger._debug("Mounting keyboard demo");

  const root = createRoot(demoElement);
  root.render(
    <ProvideAppDevStateRenderers>
      <ProvideWorldStateDev world={world}>
        <KeyboardDemoApp rootUID={rootUID} />
      </ProvideWorldStateDev>
    </ProvideAppDevStateRenderers>,
  );

  rootLogger._debug("Keyboard demo mounted successfully");
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap);
} else {
  bootstrap();
}
